import React, { useReducer, useState } from "react";
import PropTypes from "prop-types";
import CounterTable from "../../elements/Tables/CounterTable/CounterTable";
import CounterCreationForm from "../../elements/Forms/CounterCreationForm/CounterCreationForm";

import { useFetch } from "../../../Utils/useFetch";

import {
  FETCH_ALL_COUNTER_API,
  FETCH_ALL_COUNTERS_INCLUDING_INACTIVE_API,
  FETCH_ALL_DEPT_API,
} from "../../../Constants/Apis";
import { Button, Flex, Input, message, Modal } from "antd";
import { reducer } from "../../../Utils/CommonUtils";
import { deleteCounter } from "../../../Services/CounterService";

const { Search } = Input;

const CounterPage = ({ history, userData }) => {
  const initialState = {
    searchKeyword: "",
    filteredInfo: {},
    sorter: {},
  };

  const [state, dispatch] = useReducer(reducer, initialState);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [counterId, setCounterId] = useState(null);

  const handleOpenModal = () => setIsModalVisible(true);
  const handleCloseModal = () => setIsModalVisible(false);

  const handleDelete = async (id) => {
    setCounterId(id);
    setIsModalOpen(true);
  };

  const handleOk = async () => {
    try {
      await deleteCounter(counterId);
      message.success("Counter deleted successfully");
      callReFetch();
    } catch (error) {
      message.error(
        error?.response?.data?.message ||
          "Something went wrong, failed to delete counter."
      );
    }
    setIsModalOpen(false);
  };

  const {
    fetchedData: { data },
    callReFetch,
    loading,
  } = useFetch(`${FETCH_ALL_COUNTERS_INCLUDING_INACTIVE_API}`, state);

  const {
    fetchedData: { data: DeptData },
    callReFetchDept,
    loadingDept,
  } = useFetch(`${FETCH_ALL_DEPT_API}`, state);

  const handleSearch = (value) => {
    dispatch({ type: "searchKeyword", payload: value });
    callReFetch();
  };

  return (
    <div
      style={{
        width: "100vw",
        padding: "20px",
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        style={{
          paddingBottom: "20px",
          display: "flex",
          justifyContent: "space-between",
          width: "50vw",
          maxWidth: "100vw",
        }}
      >
        <Button type="primary" onClick={handleOpenModal}>
          Create New Counter
        </Button>
        <Search
          placeholder="Search..."
          allowClear
          onSearch={handleSearch}
          style={{ width: "300px" }}
        />
      </div>

      <CounterTable
        history={history}
        loading={loading}
        data={data}
        userData={userData}
        DeptData={DeptData}
        callReFetch={callReFetch}
        dispatch={dispatch}
        handleDelete={handleDelete}
      />

      <Modal
        title="Create Counter"
        open={isModalVisible}
        footer={null}
        onCancel={handleCloseModal}
      >
        <CounterCreationForm
          history={history}
          userData={userData}
          DeptData={DeptData}
          callReFetch={callReFetch}
          onClose={handleCloseModal}
        />
      </Modal>

      <Modal
        title="Delete Counter"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={() => setIsModalOpen(false)}
      >
        <p>Are you sure you want to delete this counter?</p>
      </Modal>
    </div>
  );
};

CounterPage.propTypes = {};

export default CounterPage;
